import type { LiveEventDTO } from 'autogen/swagger/all';
import { SeeLive } from 'autogen/translation-keys/trans-website-liveevent';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';
import PageAction from 'components/shared/Routing/PageAction';
import { useTranslation } from 'react-i18next';
import EventDateString from './components/EventDateString';
import * as Styles from './components/Styles';

export type LiveEventPlaceholderProps = {
    model: LiveEventDTO;
};

export default function LiveEventPlaceholder(props: LiveEventPlaceholderProps) {
    const { model } = props;
    const { imageModel, pageAction, name, description, eventTime } = model;
    const { t } = useTranslation();

    return (
        <Styles.Container>
            {imageModel && (
                <Styles.ImageContainer>
                    {pageAction ? (
                        <PageAction action={pageAction}>
                            <PictureDeprecated {...imageModel} />
                        </PageAction>
                    ) : (
                        <PictureDeprecated {...imageModel} />
                    )}
                </Styles.ImageContainer>
            )}
            <Styles.EventContentContainer>
                <Styles.EventContent>
                    <Styles.EventTitle>{name}</Styles.EventTitle>
                    <Styles.EventDescription>{description}</Styles.EventDescription>
                    <Styles.EventDate>
                        <EventDateString dateTime={eventTime} />
                    </Styles.EventDate>
                    {pageAction && <Styles.EventLiveLink action={pageAction}>{t(SeeLive)}</Styles.EventLiveLink>}
                </Styles.EventContent>
            </Styles.EventContentContainer>
        </Styles.Container>
    );
}
